<template>
  <div class="row">
      <div class="col-md-12">
          <vuestic-widget headerText="Câmeras">
              <TableCams></TableCams>
          </vuestic-widget>
      </div>
  </div>
</template>

<script>

import TableCams from './TableCams.vue'

export default {
  name: 'ListagemCams',
  components: {
    TableCams,
  },
  data () {
    return {
    }
  },
}
</script>
